import { render } from "./ScrollBar.vue?vue&type=template&id=3daf926c&scoped=true&ts=true"
import script from "./ScrollBar.vue?vue&type=script&lang=ts"
export * from "./ScrollBar.vue?vue&type=script&lang=ts"

import "./ScrollBar.vue?vue&type=style&index=0&id=3daf926c&scoped=true&lang=css"

import exportComponent from "/home3/sli/web/public/resources/editorvue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3daf926c"]])

export default __exports__